import c from "class-c";

import UString from "@repo/utils/UString";

import styles from "./Avatar.module.scss";

declare namespace Avatar {
  type Props = {
    class?: string;
    size?: string;
  } & (
    | {
        colorValue: string;
        anonymous?: false;
      }
    | {
        anonymous: true;
      }
  );
}

function Avatar({ size = "30", class: className, ...props }: D<Avatar.Props>) {
  return (
    <svg
      class={c`${styles["avatar"]} ${className}`}
      style={{
        color: props.anonymous
          ? "var(--moderate-weak)"
          : colors[UString.hash(props.colorValue) % colors.length],
      }}
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_26_1220)">
        <path
          d="M15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5ZM15 6.25C17.075 6.25 18.75 7.925 18.75 10C18.75 12.075 17.075 13.75 15 13.75C12.925 13.75 11.25 12.075 11.25 10C11.25 7.925 12.925 6.25 15 6.25ZM15 24C11.875 24 9.1125 22.4 7.5 19.975C7.5375 17.4875 12.5 16.125 15 16.125C17.4875 16.125 22.4625 17.4875 22.5 19.975C20.8875 22.4 18.125 24 15 24Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_1220">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Avatar;

const colors = [
  "#7b1fa2",
  "#aa47bd",
  "#77919d",
  "#455a65",
  "#ec417a",
  "#c1175c",
  "#5d6ac0",
  "#0388d2",
  "#00579b",
  "#0098a5",
  "#00897b",
  "#004d41",
  "#68a039",
  "#346822",
  "#8c6e64",
  "#5b4238",
  "#7d57c1",
  "#512da7",
  "#ef6c00",
  "#f6511e",
  "#c0340d",
];
